import { EntityType } from "@shared/enums/general"
import { AssignOptionResponse } from "@shared/zod/schemas/responses/item"
import { UserResponse } from "@shared/zod/schemas/responses/user"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const assignableUsers = async (practiceId: string): Promise<UserResponse[]> => {
  const resp = await axiosAuth<AssignOptionResponse>({
    url: `/assign/options/${practiceId}`,
    method: "get",
  })
  return resp.data.assignableUsers
}

export const assign = async (entityType: EntityType, entityId: string, userId: string | undefined): Promise<void> => {
  await axiosAuth<void>({
    url: `/assign/${entityType}/${entityId}`,
    method: "put",
    data: { userId: userId ?? null },
  })
  return undefined
}
